import React from 'react';
import './index.scss';
import {ReactComponent as Mail} from 'assets/parts_mail.svg';

const PcFinishContact = ({
    info
}) => {

    const DispInfo = () => {
        return Array.isArray(info)
            ? info.map(line => (
                <span key={line} className="info">
                    {line}
                    <br />
                </span>
            ))
            : <span className="info">{info}</span>;
    };

    return (
        <div className="PcFinishContact">
            <div className="info">
                <DispInfo />
            </div>
            <div className="mailArea">
                <Mail/>
                <label className="mail">tokatu@r-staffing.co.jp</label>
            </div>
        </div>
    );
};

export default PcFinishContact;